import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';
import BootstrapVue from 'bootstrap-vue';
import '../bootstrap/scss-getac/bootstrap.scss'

import 'bootstrap-vue/dist/bootstrap-vue.css';

// 引入 fontawesome
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
//import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'font-awesome/css/font-awesome.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'sumoselect/sumoselect.min.css'
import 'sumoselect/jquery.sumoselect.js'

/* add icons to the library */
library.add(faUserSecret)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon) //使用kebab-case

// 引入 axios
import axios from 'axios';
import VueSession from 'vue-session';

/* 註冊所有組件為全域 */
import "@/helpers/filters";
import "@/helpers/comma";
import "@/helpers/datepicker";
import "@/helpers/vue-number";
import "@/helpers/mail-builder";
import "@/helpers/quote-setter";
import "@/helpers/comma-int";
//import moment from 'moment';
import * as moment from 'moment/moment';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/third_party/font_awesome.min.css';
import 'froala-editor/css/third_party/image_tui.min.css';
import 'froala-editor/css/third_party/spell_checker.min.css';

/*import 'froala-editor/js/plugins.pkgd.min.js';*/
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min.js';
import 'froala-editor/js/third_party/image_tui.min.js';
import 'froala-editor/js/third_party/spell_checker.min.js';
Vue.use(VueFroala);

import GtcMultiSelect from '../src/components/framework/GtcMultiSelect'
import GtcTextBox from '../src/components/framework/GtcTextBox'
import GtcNumber from '../src/components/framework/GtcNumber'
import GtcTextarea from '../src/components/framework/GtcTextarea'
import GtcFroala from '../src/components/framework/GtcFroala'
import GtcFtieFroala from '../src/components/framework/GtcFtieFroala'
import GtcFtiePage from '../src/components/framework/GtcFtiePage'
import GtcOpportunity from '../src/components/framework/GtcOpportunity'
import GtcAccountLink from '../src/components/framework/GtcAccountLink'
import GtcOpportunityInventory from '../src/components/framework/GtcOpportunityInventory'
import GtcFTIE from '../src/components/framework/GtcFTIE'
import GtcFtieTag from '../src/components/framework/GtcFtieTag'
import EsInfoTab from '../src/components/framework/EsInfoTab'
import KickoffFiles from '../src/components/framework/KickoffFiles'
import TaskPage from '../src/components/task-management/TaskPage'
import AccountPage from '../src/components/opty-management/AccountPage'
import DemoLoanPage from '../src/components/opty-management/DemoLoanPage'
import { BootstrapVueIcons } from 'bootstrap-vue'

import GtcFtieDashboardLink from '../src/components/framework/GtcFtieDashboardLink'
import SfdcPrdLine from '../src/components/framework-sfdc/SfdcPrdLineSync'
import SfdcPrdLineSAView from '../src/components/framework-sfdc/SfdcPrdLineDisplayOnly'
import SfdcAttachments from '../src/components/framework-sfdc/SfdcAttachments'
import SfdcDemoLoans from '../src/components/framework-sfdc/SfdcDemoLoans'
import SfdcEngineeringServices from '../src/components/framework-sfdc/SfdcEngineeringServices'
import EtoSectorSkuPn from '../src/components/framework-sector-sku/ETOSectorSkuPn'
import FTIEOpenAIChat from '../src/components/framework-gen-ai/FTIEOpenAIChat'
import AutoNreTrigger from '../src/components/auto-nre/AutoNreTrigger'
import AutoPnTrigger from '../src/components/auto-pn/AutoPnTrigger'
import CustomizationTracking from '../src/components/framework/CustomizationTracking'
import  { safeHtml } from '../src/helpers/vue-safehtml'
import  { safeUrl } from '../src/helpers/vue-url'

import _ from 'lodash';
import 'jquery-ui-dist/jquery-ui.min.js';
Object.defineProperty(Vue.prototype, '_', { value: _ });
Object.defineProperty(Vue.prototype, 'console', { value: console });
Vue.prototype.safeUrl = safeUrl
Vue.prototype.safeHtml = safeHtml

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.use(BootstrapVue);
Vue.use(VueSession,{persist: true});
Vue.component('gtc-multi-select', GtcMultiSelect);
Vue.component('gtc-text-box', GtcTextBox);
Vue.component('gtc-number', GtcNumber);
Vue.component('gtc-textarea', GtcTextarea);
Vue.component('gtc-froala', GtcFroala);
Vue.component('gtc-ftie-froala', GtcFtieFroala);
Vue.component('eto-sector-sku', EtoSectorSkuPn);
Vue.component('gtc-ftie-page', GtcFtiePage);
Vue.component('gtc-opportunity', GtcOpportunity);
Vue.component('gtc-account-link', GtcAccountLink);
Vue.component('gtc-ftie', GtcFTIE);
Vue.component('gtc-link-to-ftie-dashboard', GtcFtieDashboardLink);
Vue.component('gtc-opty-inventory', GtcOpportunityInventory);
Vue.component('sfdc-prd-line', SfdcPrdLine);
Vue.component('sfdc-prd-line-view-only', SfdcPrdLineSAView);
Vue.component('gtc-ftie-tag', GtcFtieTag);
Vue.component('es-info-tab', EsInfoTab);
Vue.component('nre-kickoff-files', KickoffFiles);
Vue.component('ftie-openai-chat', FTIEOpenAIChat);
Vue.component('task-page', TaskPage);
Vue.component('account-page', AccountPage);
Vue.component('demo-loan-page', DemoLoanPage);
Vue.component('sfdc-demo-loans', SfdcDemoLoans);
Vue.component('sfdc-attachments', SfdcAttachments);
Vue.component('sfdc-engineering-services', SfdcEngineeringServices);
Vue.component('auto-nre-trigger', AutoNreTrigger);
Vue.component('auto-pn-trigger', AutoPnTrigger);
Vue.component('cust-tracking', CustomizationTracking);


Vue.use(BootstrapVueIcons)

Vue.prototype.$axios = axios;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.interceptors.request.use(
  config => {
    // 如果需要，可以在這裡動態添加或修改全域的 `params`
    const value = `; ${document.cookie}`;
    let token = '';
    const match = document.cookie.match(new RegExp('(^| )token=([^;]+)'));
    token = match ? match[2] : null;
    config.params = {
      ...config.params,
      token: encodeURI(token),
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

window.eventHub = new Vue();

Vue.prototype.moment = moment;

// 拦截器  to：要去哪  next:去跳转  from:从哪来
router.beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {

    // 当前要去的url只有登录后才能访问
    if (store.state.token) {

      Vue.nextTick(() => {
        document.title = 'ETO NRE - ' + to.name;
      });

      // token为true表示可以继续访问
      next()

    } else {
      // token不为true跳转到登录页面
      next({ path: '/azure-login', query: { backUrl: to.fullPath } })
    }
  } else {
    // url不需要访问即可以访问
    next()
  }
});

/* eslint-disable no-new */
new Vue({
  router,
  axios,
  store,
  data() {
    return {
      nodeEnv: process.env.NODE_ENV,
      baseUrl: process.env.BASE_URL,
      frontEndUrl: process.env.FRONTEND_URL,
      uatFrontendUrl: process.env.UAT_FRONTEND_URL,
      authUrl: process.env.AUTH_URL,
      salesforceUrl: process.env.SALESFORCE,
      ftieTwUrl: process.env.FTIE_V3,
    }
  },
  computed: {
    maxRequestLength() {
      return 10485760;
    }
  },
  created() {

  },
  methods: {
    msgBoxConfirm(msg, callback, options) {
      const h = this.$createElement;
      let messageVNode = h('pre', { domProps: { innerHTML: safeHtml(msg), class: 'mb-0', style: 'white-space: pre-line;' } });
      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: options.title || 'Remind',
        titleClass: options.titleClass || 'text-primary',
        size: options.size || 'sm',
        buttonSize: options.buttonSize || 'sm',
        okVariant: options.okVariant || 'primary',
        okTitle: options.okTitle || 'OK',
        cancelTitle: options.cancelTitle || 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {

        if (_.isFunction(callback)) callback(value);

      }).catch(err => {
        // An error occurred
      })
    },

    getTime(date) {
      if (!_.isDate(date)) date = new Date();
      return moment(date).format('YYYY-MM-DD hh:mm:ss');
    },
  },
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js